import LivenessPage from './LivenessPage';

export default LivenessPage;
